import { useState, useEffect, useCallback } from 'react';
import { Button } from 'react-bootstrap';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import TextComponent from 'components/Input/TextComponent';

// 申請却下モーダル画面
function ApprovalRejectModal(props) {
  const [show, setShow] = useState();
  // 却下理由
  const [rejectReason, setRejectReason] = useState('');

  useEffect(() => {
    if (props.params.show) {
      console.log(props.params);
      setRejectReason('');
      setShow(true);
    }
  }, [props.params]);

  // キャンセルボタンクリック
  const handelOnClickCancel = () => {
    setShow(false);
  };

  // OKボタンクリック
  const handelOnClickOk = () => {
    props.params.okCallBack(rejectReason);
    setShow(false);
  };

  // 編集処理
  const handleOnChangeRejectionReason = (target) => {
    setRejectReason(target.value);
  };

  return (
    <Dialog fullWidth={true} maxWidth={'sm'} open={show}>
      <DialogTitle className="confirm-modal-header p-2">確認</DialogTitle>
      <DialogContent className="p-2">
        <div className="mb-2">申請を却下します。よろしいですか？</div>
        <TextComponent
          type="textarea"
          placeholder={'却下理由を入力してください。'}
          rows="6"
          value={rejectReason}
          onChange={handleOnChangeRejectionReason}
        ></TextComponent>
      </DialogContent>
      <DialogActions className="p-3" style={{ justifyContent: 'space-between' }}>
        <Button variant="secondary" className="footer-button" onClick={handelOnClickCancel}>
          キャンセル
        </Button>
        <Button
          variant="primary"
          className="btn-fill footer-button"
          onClick={() => {
            handelOnClickOk();
          }}
          disabled={rejectReason === ''}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ApprovalRejectModal;
